export default function a (str, len) {
  const _len = str.length
  len = len * 2
  let blen = 0
  let _str = ''
  for (let i = 0; i < _len; i++) {
    if ((str.charCodeAt(i) & 0xff00) != 0) {
      blen++
    }
    blen++
    if (blen <= len) {
      _str += str[i]
    } else {
      _str += '...'
      return _str
    }
  }
  return _str
}

export function getStrLen (str) {
  const len = str.length
  let blen = 0
  for (let i = 0; i < len; i++) {
    if ((str.charCodeAt(i) & 0xff00) != 0) {
      blen++
    }
    blen++
  }
  return blen
}
